module.exports = __webpack_public_path__ + "static/media/bg.d5a44e26.png";